import React, { useState } from "react";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { Question } from "../../../../interfaces/questions.interface";
import { QuestionsSection } from "../QuestionsSection";
import { AddedQuestionsSection } from "../AddedQuestionsSection";
import { StepTwoProps } from "../types";

export const StepTwo: React.FC<StepTwoProps> = ({ 
  values, 
  onQuestionAdded, 
  onQuestionEdited,
  onRemoveQuestion, 
  errors = {} 
}) => {
  const [expandedSection, setExpandedSection] = useState<'form' | 'added'>('added');
  const [editingQuestionIndex, setEditingQuestionIndex] = useState<number | null>(null);

  const validQuestions = values.questions?.filter(q => q !== null) || [];

  const handleToggle = (section: 'form' | 'added') => (e: React.MouseEvent) => {
    e.preventDefault();
    setExpandedSection(section);
  };

  const handleEditQuestion = (index: number) => {
    setEditingQuestionIndex(index);
    setExpandedSection('form');
  };

  const handleQuestionEdited = (editedQuestion: Omit<Question, '_id' | 'chapter'>) => {
    if (editingQuestionIndex !== null) {
      onQuestionEdited(editingQuestionIndex, editedQuestion);
      setEditingQuestionIndex(null);
      setExpandedSection('added');
    }
  };

  const questionFormHeader = (options: any) => {
    const isExpanded = expandedSection === 'form';
    return (
      <div className="flex align-items-center gap-2 p-3">
        <span className="font-bold">
          {editingQuestionIndex !== null ? 'Modifier la question' : 'Ajouter une question'}
        </span>
        <Button 
          icon={!isExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'}   
          className="ml-auto bg-transparent border-none text-gray-400 focus:ring-0"
          onClick={handleToggle('form')}
        />
      </div>
    );
  };

  const addedQuestionsHeader = (options: any) => {
    const isExpanded = expandedSection === 'added';
    return (
      <div className="flex align-items-center gap-2 p-3">
        <span className="font-bold">Questions ajoutées ({validQuestions.length})</span>
        <Button 
          icon={!isExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'}   
          className="ml-auto bg-transparent border-none text-gray-400 focus:ring-0"
          onClick={handleToggle('added')}
        />
      </div>
    );
  };

  return (
    <div className="step-container">
      {values.category && (
        <>
          <div className="space-y-4">
            {validQuestions.length > 0 && (
              <Panel 
                headerTemplate={addedQuestionsHeader} 
                toggleable 
                collapsed={expandedSection !== 'added'}
                className='border-none'
                onToggle={() => {}}
              >
                <AddedQuestionsSection 
                  questions={validQuestions} 
                  onRemoveQuestion={onRemoveQuestion}
                  onEditQuestion={handleEditQuestion}
                />
              </Panel>
            )}

            <Panel 
              headerTemplate={questionFormHeader} 
              toggleable 
              collapsed={expandedSection !== 'form'}
              className='border-none'
              onToggle={() => {}}
            >
              <QuestionsSection 
                category={values.category} 
                onQuestionAdded={editingQuestionIndex === null ? onQuestionAdded : undefined}
                editingQuestion={editingQuestionIndex !== null ? validQuestions[editingQuestionIndex] : undefined}
                onQuestionEdited={handleQuestionEdited}
              />
            </Panel>
          </div>
          {errors.questions && <div className="text-red-500 text-sm mt-1">{errors.questions}</div>}
        </>
      )}
    </div>
  );
};
